import { toast } from "sonner";

/* IG Story export — 1080x1920 canvas with lime Eventom sticker frame. */
export async function exportStory({ imageUrl, title, city, date }) {
  const t = toast.loading("Building your story…");
  try {
    const img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.crossOrigin = "anonymous";
      im.onload = () => resolve(im);
      im.onerror = reject;
      im.src = imageUrl;
    });

    const W = 1080, H = 1920;
    const c = document.createElement("canvas");
    c.width = W; c.height = H;
    const ctx = c.getContext("2d");

    // bg — matte black with violet/coral glow
    ctx.fillStyle = "#0A0A0A"; ctx.fillRect(0, 0, W, H);
    let g = ctx.createRadialGradient(W * 0.85, H * 0.08, 0, W * 0.85, H * 0.08, 700);
    g.addColorStop(0, "rgba(123,47,255,0.4)"); g.addColorStop(1, "transparent");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    g = ctx.createRadialGradient(W * 0.1, H * 0.9, 0, W * 0.1, H * 0.9, 650);
    g.addColorStop(0, "rgba(255,77,109,0.3)"); g.addColorStop(1, "transparent");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

    // photo — centered, cover-cropped, rounded, lime sticker frame
    const px = 90, py = 380, pw = W - 180, ph = 1125;
    const r = 36;
    ctx.save();
    ctx.beginPath();
    ctx.roundRect(px, py, pw, ph, r);
    ctx.clip();
    const scale = Math.max(pw / img.width, ph / img.height);
    const dw = img.width * scale, dh = img.height * scale;
    ctx.drawImage(img, px + (pw - dw) / 2, py + (ph - dh) / 2, dw, dh);
    ctx.restore();
    ctx.lineWidth = 14; ctx.strokeStyle = "#AAEE00";
    ctx.shadowColor = "rgba(170,238,0,0.6)"; ctx.shadowBlur = 40;
    ctx.beginPath(); ctx.roundRect(px, py, pw, ph, r); ctx.stroke();
    ctx.shadowBlur = 0;

    // top badge
    ctx.fillStyle = "#AAEE00";
    ctx.beginPath(); ctx.roundRect(90, 200, 330, 76, 38); ctx.fill();
    ctx.fillStyle = "#0A0A0A";
    ctx.font = "700 34px 'Space Mono', monospace";
    ctx.fillText("★ I WAS HERE", 130, 250);

    // title
    ctx.fillStyle = "#FFFFFF";
    ctx.font = "800 64px 'Space Grotesk', sans-serif";
    const words = (title || "Eventom Event").split(" ");
    let line = "", y = 1620;
    const lines = [];
    for (const w of words) {
      if (ctx.measureText(line + w).width > W - 180) { lines.push(line.trim()); line = w + " "; }
      else line += w + " ";
    }
    lines.push(line.trim());
    lines.slice(0, 2).forEach((l, i) => ctx.fillText(l, 90, y + i * 74));

    // meta
    ctx.fillStyle = "#AAEE00";
    ctx.font = "700 32px 'Space Mono', monospace";
    ctx.fillText([city, date].filter(Boolean).join(" · ").toUpperCase(), 90, y + Math.min(lines.length, 2) * 74 + 20);

    // brand footer — wordmark + lime square
    ctx.fillStyle = "#FFFFFF";
    ctx.font = "800 52px 'Space Grotesk', sans-serif";
    ctx.fillText("eventom", 90, H - 70);
    ctx.fillStyle = "#AAEE00";
    ctx.fillRect(90 + ctx.measureText("eventom").width + 14, H - 106, 34, 34);
    ctx.fillStyle = "rgba(255,255,255,0.55)";
    ctx.font = "400 28px 'Space Mono', monospace";
    ctx.textAlign = "right";
    ctx.fillText("eventom.online", W - 90, H - 70);
    ctx.textAlign = "left";

    const blob = await new Promise((res) => c.toBlob(res, "image/png"));
    const file = new File([blob], "eventom-story.png", { type: "image/png" });
    toast.dismiss(t);
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], title: "My Eventom Story" }); return; } catch {}
    }
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "eventom-story.png"; a.click();
    URL.revokeObjectURL(url);
    toast.success("Story saved — post it to your IG! ✦");
  } catch (e) {
    toast.dismiss(t);
    toast.error("Couldn't build the story for this image — try another photo");
  }
}
